import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@env/environment';
import {
  ICreateSettlement2Info,
  IInitialSettlementInfo,
  IUploadSettlementFile,
} from '@core/interfaces/settlement.Interface';
import { ResponseData } from '@core/types/types';
import { IUploadClaimFileResponse } from '@core/interfaces/claim.Interface';
import { IAssistedPatientCompanion, IRegisterCompanionAndAssitedPatient, IRegisterCompanionAndAssitedPatientResponse } from '@core/interfaces/assisted-patient.Interface';

type AssistedPatientType = 'MENOR_EDAD' | 'DISCAPACITADO' | 'ENVEJECIENTE';

const data = of([
  {
    id: '1',
    name: 'Jeremy Solano',
    kinship: 'PADRE',
  },
  {
    id: '2',
    name: 'Jeremy Solano',
    kinship: 'MADRE',
  },
  {
    id: '3',
    name: 'Jeremy Solano',
    kinship: 'HERMANO/A',
  },
]);

@Injectable({
  providedIn: 'root',
})
export class AssistedPatientService {
  private readonly apiUrl = environment.apiUrl;

  private readonly _isAssistedPatient = signal<boolean>(false);
  private readonly _assistedPatientType = signal< AssistedPatientType | undefined>(undefined);
  private readonly _companions = signal<IAssistedPatientCompanion[] | undefined>(undefined);
  private readonly _selectedCompanion = signal<IAssistedPatientCompanion | undefined>(undefined);

  isAssistedPatient = this._isAssistedPatient.asReadonly();
  assistedPatientType = this._assistedPatientType.asReadonly();
  selectedCompanion = this._selectedCompanion.asReadonly();
  companions = this._companions.asReadonly();

  constructor(private readonly http: HttpClient) {}

  setIsAssistedPatient(value: boolean) {
    this._isAssistedPatient.set(value);
  }

  setAssistedPatientType(value?: AssistedPatientType) {
    this._assistedPatientType.set(value);
  }

  setCompanions(value: IAssistedPatientCompanion[]) {
    this._companions.set(value);
  }

  setSelectedCompanion(value?: IAssistedPatientCompanion) {
    this._selectedCompanion.set(value);
  }

  getAssistedPatientCompanions(identificationNumber: string): Observable<ResponseData<IAssistedPatientCompanion[]>> {
    return this.http.get(
      `${this.apiUrl}/catalogos/paciente/${identificationNumber}/acompanantes`,
    ) as Observable<ResponseData<IAssistedPatientCompanion[]>>;
  }

  registerAssistedPatientAndCompanion(data: IRegisterCompanionAndAssitedPatient): Observable<ResponseData<IRegisterCompanionAndAssitedPatientResponse>> {
    return this.http.post(
      `${this.apiUrl}/api/v1/paciente-asistido/registrar`,
      data
    ) as Observable<ResponseData<IRegisterCompanionAndAssitedPatientResponse>>;
  }
}
